module.exports = __webpack_public_path__ + "static/img/zhengqingsheng.169c3d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/touxiang/zhengqingsheng.png
// module id = V7+o
// module chunks = 0